import { render } from "./TheNavBar.vue?vue&type=template&id=34ffba44&scoped=true&ts=true"
import script from "./TheNavBar.vue?vue&type=script&lang=ts"
export * from "./TheNavBar.vue?vue&type=script&lang=ts"

import "./TheNavBar.vue?vue&type=style&index=0&id=34ffba44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\deadsouls-staking\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ffba44"]])

export default __exports__